import React from "react";
import { TextField, TableCell, TableHead, MenuItem } from "@material-ui/core";
import PropTypes from "prop-types";
import { DropDown } from "../../../common/DropDown";
import { useStyles } from "./styles";

const CreateFilterElement = ({ filter }) => {
  switch (filter.type) {
    case "text":
      return (
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          id={filter.id}
          htmlFor={filter.id}
          name={filter.name}
          label={filter.label}
          onChange={(event) => {
            filter.onChange(event);
          }}
        />
      );
    case "dropDown":
      return (
        <DropDown
          data={filter.options}
          label={filter.label}
          name={filter.name}
          id={filter.id}
          state={filter.value}
          onChange={(event) => {
            filter.onChange(event);
          }}
        />
      );
    case "textField":
      return (
        <TextField
          name={filter.name}
          label={filter.label}
          variant="outlined"
          margin="normal"
          onChange={(event) => {
            filter.onChange(event);
          }}
          fullWidth
          select
          style={{ width: 200 }}
          value={filter.value}
        >
          {filter.options.map((option, index) => (
            <MenuItem
              key={option.id}
              value={option.id}
              divider={filter.options.length - 1 === index}
            >
              {option.text}
            </MenuItem>
          ))}
          <MenuItem key={0} value="All" divider={0}>
            All
          </MenuItem>
        </TextField>
      );
    default:
      return null;
  }
};

CreateFilterElement.propTypes = {
  filter: PropTypes.instanceOf(Object).isRequired,
};

export const TheadTable = ({ filters }) => {
  const classes = useStyles({
    sizeFilters: filters.length,
  });
  return (
    <TableHead className={classes.theadContainer}>
      {filters.map((filter) => (
        <TableCell component="th" className={classes.tableCell} key={filter.id}>
          <CreateFilterElement filter={filter} />
        </TableCell>
      ))}
    </TableHead>
  );
};

TheadTable.propTypes = {
  filters: PropTypes.instanceOf(Array).isRequired,
};
